import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import MultipleGoogleMediaUpload from '../../GoogleAssetGroup/GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'
import GoogleAdPreviewDiscover1 from '../../GoogleAssetsSliderPreview/Previews/GoogleAdPreviewDiscover1'

import { FILE_URL, LANDSCAPE_IMAGE, landscapeImageHeight, landscapeImageWidth } from '../../fields'
import { landscapeImageValidationSchema } from '../../validations'

import useCommonStyles from '../../../../../styles/common/stepForms'

const stepFields = [LANDSCAPE_IMAGE]

function LandscapeImageStep({ formik, handleStepChange, isStepFieldsValid }) {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  const { values } = formik

  const fileUrl = values[LANDSCAPE_IMAGE][0]?.[FILE_URL]

  const handleContinue = () => {
    handleStepChange(stepFields, values)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Upload at least 1 landscape image with ratio 1.91:1')}</div>
      <div className={commonClasses.stepBody}>
        <GoogleAdPreviewDiscover1
          values={values}
          fileUrl={fileUrl}
          width={landscapeImageWidth}
          height={landscapeImageHeight}
        />
        <MultipleGoogleMediaUpload
          formik={formik}
          FileItemPath={LANDSCAPE_IMAGE}
          validationSchema={landscapeImageValidationSchema}
          isStepFieldsValid={isStepFieldsValid}
          addAnotherButtonText={'Add another landscape image'}
          width={landscapeImageWidth}
          height={landscapeImageHeight}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default LandscapeImageStep
